const globalState = {
	isAuthenticated: false,
};

export default globalState;
